import WebService from "../WebService";
const Product = {
  gets(params) {
    return WebService.get("/products?" + params);
  },
  getsInSeller(params) {
    return WebService.get("/products-in-seller?" + params);
  },
  // add(data) {
  //   return WebService.post("/products", { ...data });
  // },
  getsInSeller(params) {
    return WebService.get("/products-in-seller?" + params);
  },
  add(data) {
    return WebService.post("/products", data);
  },
  // update(data) {
  //   return WebService.post("/products/" + data.product_id, { ...data });
  // }
  update(data, id) {
    return WebService.post(`/products/${id}`, data);
  },
  updateQty(data, id) {
    return WebService.post(`/products-qty/${id}`, data);
  },
  trash(data, id) {
    return WebService.post(`/trashed-product/${id}`, data);
  }
};
export default Product;
